<script lang="ts">
  import { ExternalLink, QrCode, RefreshCw } from "lucide-svelte";
  import { Button } from "$lib/components/ui/button/index.js";
  import * as Popover from "$lib/components/ui/popover/index.js";
  import QRCode from '@castlenine/svelte-qrcode';

  interface Props {
    currentSite: any;
    siteHealth: 'testing' | 'online' | 'offline';
    onCheckHealth: () => void;
    tl?: any;
    t: (path: string, params?: Record<string, any>) => string;
  }

  let { currentSite, siteHealth, onCheckHealth, tl = {}, t }: Props = $props();
</script>

<div class="flex items-center justify-between border-b pb-4">
  <div class="flex items-center gap-2.5">
    <h1 class="text-xl font-bold tracking-tight">
      {#if currentSite?.primary_domain}
        <a 
          href="http://{currentSite.primary_domain}" 
          target="_blank" 
          rel="noopener noreferrer"
          class="hover:text-primary transition-colors inline-flex items-center gap-1.5 group"
        >
          {currentSite?.name || t('dashboard.default_site_name')}
          <ExternalLink class="size-4 text-muted-foreground group-hover:text-primary transition-colors" />
        </a>
        <Popover.Root>
          <Popover.Trigger class="inline-flex items-center justify-center size-5 text-muted-foreground hover:text-foreground hover:bg-muted rounded-md transition-colors cursor-pointer" title={tl.show_qrcode || '显示网站二维码'}>
            <QrCode class="size-3.5" />
          </Popover.Trigger>
          
          <Popover.Content class="w-48 p-3 rounded-xl border bg-popover text-popover-foreground shadow-md z-50">
            <div class="flex flex-col items-center gap-2">
              <div class="size-36 bg-white p-1 rounded-lg border border-border flex items-center justify-center">
                <QRCode data="http://{currentSite.primary_domain}" isResponsive />
              </div>
              <span class="text-[10px] text-muted-foreground text-center truncate w-full">
                {t('dashboard.qrcode_title', { defaultValue: 'Scan to Visit Site' })}
              </span>
            </div>
          </Popover.Content>
        </Popover.Root>
      {:else}
        {currentSite?.name || t('dashboard.default_site_name')}
      {/if}
    </h1>

    <div class="flex items-center gap-1.5 ml-1">
      {#if siteHealth === 'online'}
        <span class="relative flex h-2.5 w-2.5" title={t('dashboard.status.online_title')}>
          <span class="animate-ping absolute inline-flex h-full w-full rounded-full bg-emerald-400 opacity-75"></span>
          <span class="relative inline-flex rounded-full h-2.5 w-2.5 bg-emerald-500"></span>
        </span>
        <span class="text-xs text-emerald-600 dark:text-emerald-400 font-medium">{t('dashboard.status.online')}</span>
      {:else if siteHealth === 'testing'}
        <RefreshCw class="size-3 animate-spin text-muted-foreground" />
        <span class="text-xs text-muted-foreground">{t('dashboard.status.testing')}</span>
      {:else}
        <span class="h-2.5 w-2.5 rounded-full bg-destructive" title={t('dashboard.status.offline_title')}></span>
        <span class="text-xs text-destructive font-medium">{t('dashboard.status.offline')}</span>
      {/if}
    </div>
  </div>

  <Button variant="ghost" size="sm" onclick={onCheckHealth} class="text-xs text-muted-foreground">
    <RefreshCw class="size-3.5 mr-1" />
    {t('dashboard.status.recheck')}
  </Button>
</div>